import { render, staticRenderFns } from "./Pendencia.vue?vue&type=template&id=a8a569b2&scoped=true&"
import script from "./Pendencia.vue?vue&type=script&lang=js&"
export * from "./Pendencia.vue?vue&type=script&lang=js&"
import style0 from "./Pendencia.vue?vue&type=style&index=0&id=a8a569b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a569b2",
  null
  
)

export default component.exports